import {ApiClientCommunication} from 'neo-common';
import {RealityCheckGetInfoResponse} from '../Responses/RealityCheckGetInfoResponse';

export class RealityCheckGetInfoRequest extends ApiClientCommunication.RequestBase<RealityCheckGetInfoResponse> {
    createResponse(responseJson: ApiClientCommunication.Types.RawResponseType): RealityCheckGetInfoResponse {
        return new RealityCheckGetInfoResponse(responseJson);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Requests/RealityCheckGetInfoRequest.ts
 **/